import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { configService } from "./Config/ConfigService";

class AppInsights {
  private appInsights: ApplicationInsights | undefined;

  async load() {
    const config = await configService.getConfiguration();

    if (config && config.ApplicationInsights.ConnectionString) {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: config.ApplicationInsights.ConnectionString
        }
      });
      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }

  async logError(ex: Error) {
    this.appInsights?.trackException({ exception: ex });
  }
}

export const appInsights = new AppInsights();
